export const DEFAULT_MODEL = 'gpt-5.2';
